import React from "react";
import {css} from "@panda/css";

import {SearchIcon} from "@pg-design/icons-module";
import {InputCore, InputWrapper} from "@pg-design/inputs-module";
import {NAVIGATION_MOBILE_TEST_IDS} from "@pg-mono/test-ids";

import {ISearchInputValue} from "../../../search/components/ISearchInputValue";
import {RegionPillsOverflow} from "../../../search/components/RegionPillsOverflow";
import {SearchTab} from "../../../search/types/SearchTab";

interface IProps {
    searchValue?: ISearchInputValue;
    onClick: () => void;
}

export const HomepageHeroMobileSearchPlaceholder = (props: IProps) => {
    const selectedRegionLabels = getSelectedRegionLabels(props.searchValue);
    const selectedSearchLabel = getSelectedSearchLabel(props.searchValue);
    const selectedRegionWrapperRef = React.useRef<HTMLDivElement>(null);
    const selectedRegionAddLabelRef = React.useRef<HTMLSpanElement>(null);

    return (
        <div className={heroWrapperStyle}>
            <div className={heroPlaceholderStyle} onClick={props.onClick}>
                <div className={heroIconWrapperStyle}>
                    <SearchIcon size="2.4" />
                </div>

                {selectedRegionLabels.length > 0 ? (
                    <div
                        ref={selectedRegionWrapperRef}
                        className={selectedRegionWrapperStyle}
                        data-testid={NAVIGATION_MOBILE_TEST_IDS.SEARCH_BAR.INPUT}
                        data-homepage-selected-region-wrapper="true"
                    >
                        <RegionPillsOverflow
                            regionLabels={selectedRegionLabels}
                            wrapperClassName={selectedRegionPillsWrapperStyle}
                            availableWidthElementRef={selectedRegionWrapperRef}
                            reservedWidthElementRef={selectedRegionAddLabelRef}
                            renderPill={(regionPillLabel, {isVisible, index}) => (
                                <span
                                    key={`${regionPillLabel}-${index.toString()}`}
                                    className={selectedRegionPillStyle}
                                    data-visible-region-pill-label={isVisible ? true : undefined}
                                >
                                    {regionPillLabel}
                                </span>
                            )}
                        />
                        <span ref={selectedRegionAddLabelRef} className={selectedRegionAddLabelStyle} data-homepage-add-location-label="true">
                            Dodaj lokalizację
                        </span>
                    </div>
                ) : (
                    <InputWrapper className={heroInputWrapperStyle}>
                        <InputCore
                            placeholder="Gdzie chcesz mieszkać?"
                            value={selectedSearchLabel ?? ""}
                            readOnly
                            dataTestId={NAVIGATION_MOBILE_TEST_IDS.SEARCH_BAR.INPUT}
                        />
                    </InputWrapper>
                )}
            </div>
        </div>
    );
};

const getSelectedRegionLabels = (searchValue?: ISearchInputValue) => {
    if (searchValue?.tabType !== SearchTab.Regions || searchValue.regions.length === 0) {
        return [];
    }

    return searchValue.regions.map((region) => region.name);
};

const getSelectedSearchLabel = (searchValue?: ISearchInputValue) => {
    switch (searchValue?.tabType) {
        case SearchTab.Offers:
            return searchValue.label || searchValue.offer.name;
        case SearchTab.Places:
            return searchValue.label || searchValue.place.description;
        case SearchTab.Vendors:
            return searchValue.label || searchValue.vendor.name;
        default:
            return null;
    }
};

const heroWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "none",
    overflow: "visible",
    borderRadius: 0
});

const heroPlaceholderStyle = css({
    cursor: "pointer",
    position: "relative",
    display: "flex",
    height: "56px",
    backgroundColor: "#fff",
    borderRadius: "999px",
    overflow: "hidden",
    pl: 3,
    gap: 1
});

const heroIconWrapperStyle = css({
    flex: "0 0 auto",
    cursor: "text",
    zIndex: 1,
    height: "100%",
    width: "2.4rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    color: "var(--colors-gray-900)"
});

const heroInputWrapperStyle = css({
    height: "56px",
    pl: 0,
    pr: 2,
    width: "100%",
    border: 0,
    borderRadius: 0,
    display: "flex",
    alignItems: "center",

    "&:focus": {
        outline: "none"
    },

    "& input": {
        color: "var(--colors-gray-900)",
        fontSize: "1.6rem",
        lineHeight: "2.4rem"
    },

    "& input::placeholder": {
        color: "var(--colors-gray-900)",
        opacity: 1
    }
});

const selectedRegionWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    flex: "1 1 auto",
    minWidth: 0,
    height: "100%",
    gap: 1,
    pr: 2,
    overflow: "hidden"
});

const selectedRegionPillsWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    flexWrap: "nowrap",
    gap: 1
});

const selectedRegionPillStyle = css({
    display: "block",
    flex: "0 1 auto",
    maxWidth: "18rem",
    height: "32px",
    minHeight: "32px",
    px: 1,
    overflow: "hidden",
    borderRadius: "999px",
    backgroundColor: "var(--colors-primary)",
    color: "var(--colors-gray-900)",
    fontSize: "1.2rem",
    fontWeight: 500,
    lineHeight: "32px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});

const selectedRegionAddLabelStyle = css({
    minWidth: 0,
    overflow: "hidden",
    color: "var(--colors-gray-900)",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
import React from "react";
import {css} from "@panda/css";

import {SearchIcon} from "@pg-design/icons-module";
import {InputCore, InputWrapper} from "@pg-design/inputs-module";
import {NAVIGATION_MOBILE_TEST_IDS} from "@pg-mono/test-ids";

import {ISearchInputValue} from "../../../search/components/ISearchInputValue";
import {RegionPillsOverflow} from "../../../search/components/RegionPillsOverflow";
import {SearchTab} from "../../../search/types/SearchTab";

interface IProps {
    searchValue?: ISearchInputValue;
    onClick: () => void;
}

export const HomepageHeroMobileSearchPlaceholder = (props: IProps) => {
    const selectedRegionLabels = getSelectedRegionLabels(props.searchValue);
    const selectedSearchLabel = getSelectedSearchLabel(props.searchValue);
    const selectedRegionWrapperRef = React.useRef<HTMLDivElement>(null);
    const selectedRegionAddLabelRef = React.useRef<HTMLSpanElement>(null);

    return (
        <div className={heroWrapperStyle}>
            <div className={heroPlaceholderStyle} onClick={props.onClick}>
                <div className={heroIconWrapperStyle}>
                    <SearchIcon size="2.4" />
                </div>

                {selectedRegionLabels.length > 0 ? (
                    <div
                        ref={selectedRegionWrapperRef}
                        className={selectedRegionWrapperStyle}
                        data-testid={NAVIGATION_MOBILE_TEST_IDS.SEARCH_BAR.INPUT}
                        data-homepage-selected-region-wrapper="true"
                    >
                        <RegionPillsOverflow
                            regionLabels={selectedRegionLabels}
                            wrapperClassName={selectedRegionPillsWrapperStyle}
                            availableWidthElementRef={selectedRegionWrapperRef}
                            reservedWidthElementRef={selectedRegionAddLabelRef}
                            renderPill={(regionPillLabel, {isVisible, index}) => (
                                <span
                                    key={`${regionPillLabel}-${index.toString()}`}
                                    className={selectedRegionPillStyle}
                                    data-visible-region-pill-label={isVisible ? true : undefined}
                                >
                                    {regionPillLabel}
                                </span>
                            )}
                        />
                        <span ref={selectedRegionAddLabelRef} className={selectedRegionAddLabelStyle} data-homepage-add-location-label="true">
                            Dodaj lokalizację
                        </span>
                    </div>
                ) : (
                    <InputWrapper className={heroInputWrapperStyle}>
                        <InputCore
                            placeholder="Gdzie chcesz mieszkać?"
                            value={selectedSearchLabel ?? ""}
                            readOnly
                            dataTestId={NAVIGATION_MOBILE_TEST_IDS.SEARCH_BAR.INPUT}
                        />
                    </InputWrapper>
                )}
            </div>
        </div>
    );
};

const getSelectedRegionLabels = (searchValue?: ISearchInputValue) => {
    if (searchValue?.tabType !== SearchTab.Regions || searchValue.regions.length === 0) {
        return [];
    }

    return searchValue.regions.map((region) => region.name);
};

const getSelectedSearchLabel = (searchValue?: ISearchInputValue) => {
    switch (searchValue?.tabType) {
        case SearchTab.Offers:
            return searchValue.label || searchValue.offer.name;
        case SearchTab.Places:
            return searchValue.label || searchValue.place.description;
        case SearchTab.Vendors:
            return searchValue.label || searchValue.vendor.name;
        default:
            return null;
    }
};

const heroWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "none",
    overflow: "visible",
    borderRadius: 0
});

const heroPlaceholderStyle = css({
    cursor: "pointer",
    position: "relative",
    display: "flex",
    height: "56px",
    backgroundColor: "#fff",
    borderRadius: "999px",
    overflow: "hidden",
    pl: 3,
    gap: 1
});

const heroIconWrapperStyle = css({
    flex: "0 0 auto",
    cursor: "text",
    zIndex: 1,
    height: "100%",
    width: "2.4rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    color: "var(--colors-gray-900)"
});

const heroInputWrapperStyle = css({
    height: "56px",
    pl: 0,
    pr: 2,
    width: "100%",
    border: 0,
    borderRadius: 0,
    display: "flex",
    alignItems: "center",

    "&:focus": {
        outline: "none"
    },

    "& input": {
        color: "var(--colors-gray-900)",
        fontSize: "1.6rem",
        lineHeight: "2.4rem"
    },

    "& input::placeholder": {
        color: "var(--colors-gray-900)",
        opacity: 1
    }
});

const selectedRegionWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    flex: "1 1 auto",
    minWidth: 0,
    height: "100%",
    gap: 1,
    pr: 2,
    overflow: "hidden"
});

const selectedRegionPillsWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    flexWrap: "nowrap",
    gap: 1
});

const selectedRegionPillStyle = css({
    display: "block",
    flex: "0 1 auto",
    maxWidth: "18rem",
    height: "32px",
    minHeight: "32px",
    px: 1,
    overflow: "hidden",
    borderRadius: "999px",
    backgroundColor: "var(--colors-primary)",
    color: "var(--colors-gray-900)",
    fontSize: "1.2rem",
    fontWeight: 500,
    lineHeight: "32px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});

const selectedRegionAddLabelStyle = css({
    minWidth: 0,
    overflow: "hidden",
    color: "var(--colors-gray-900)",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
